export default (token = localStorage.token) => {
  return !!token;
};
